import apiClient from './client';

function normalizeRule(rule = {}) {
  const agentPool = rule.agent_pool || rule.target_agents || [];
  return {
    ...rule,
    agent_pool: agentPool,
    target_agents: agentPool,
  };
}

function extractRulesPayload(payload = {}) {
  const ruleList = Array.isArray(payload?.data)
    ? payload.data
    : Array.isArray(payload?.rules)
      ? payload.rules
      : Array.isArray(payload?.data?.rules)
        ? payload.data.rules
        : [];

  return {
    ...payload,
    rules: ruleList.map(normalizeRule),
  };
}

function extractRulePayload(payload = {}) {
  const rule = payload?.rule || payload?.data?.rule || payload?.data || payload;
  return {
    ...payload,
    rule: normalizeRule(rule),
  };
}

export async function fetchAssignmentRules(params = {}) {
  const response = await apiClient.get('/assignment-rules', { params });
  return extractRulesPayload(response.data);
}

export async function getAssignmentRule(id) {
  const response = await apiClient.get(`/assignment-rules/${id}`);
  return extractRulePayload(response.data);
}

export async function createAssignmentRule(payload) {
  const response = await apiClient.post('/assignment-rules', payload);
  return extractRulePayload(response.data);
}

export async function updateAssignmentRule(id, payload) {
  const response = await apiClient.put(`/assignment-rules/${id}`, payload);
  return extractRulePayload(response.data);
}

export async function deleteAssignmentRule(id) {
  const response = await apiClient.delete(`/assignment-rules/${id}`);
  return response.data;
}

export async function activateAssignmentRule(id) {
  const response = await apiClient.post(`/assignment-rules/${id}/activate`);
  return extractRulePayload(response.data);
}

export async function deactivateAssignmentRule(id) {
  const response = await apiClient.post(`/assignment-rules/${id}/deactivate`);
  return extractRulePayload(response.data);
}

export async function updateAssignmentRulePriority(id, priority) {
  const response = await apiClient.put(`/assignment-rules/${id}/priority`, { priority });
  return extractRulePayload(response.data);
}
